import * as actionTypes from './actionTypes'

// Fetch

export const fetchReportCostCenterProfits = (year, filters, inclCostCenters, inclDrivers, inclTrailers, inclFeatureCosts) => ({
    type: actionTypes.FETCH,
    payload: {
        year,
        filters,
        inclCostCenters,
        inclDrivers,
        inclTrailers,
        inclFeatureCosts
    },
})

export const fetchReportCostCenterProfitsFulfilled = data => ({
    type: actionTypes.FETCH_FULFILLED,
    payload: data,
})

export const fetchReportCostCenterProfitsRejected = message => ({
    type: actionTypes.FETCH_REJECTED,
    payload: message,
})

export const fetchReportCostCenterProfitsCancelled = () => ({
    type: actionTypes.FETCH_CANCELLED,
})

// Export

export const exportReportCostCenterProfits = (year, filters, inclCostCenters, inclDrivers, inclTrailers, inclFeatureCosts) => ({
    type: actionTypes.EXPORT,
    payload: {
        year,
        filters,
        inclCostCenters,
        inclDrivers,
        inclTrailers,
        inclFeatureCosts
    },
})

// Clear

export const clearReportCostCenterProfits = () => ({
    type: actionTypes.CLEAR,
})

// Fetch details

export const fetchReportCostCenterProfitsDetails = (id, year, month, inclCostCenters, inclDrivers, inclTrailers, inclFeatureCosts) => ({
    type: actionTypes.FETCH_DETAILS,
    payload: {
        id,
        year,
        month,
        inclCostCenters,
        inclDrivers,
        inclTrailers,
        inclFeatureCosts
    },
})

export const fetchReportCostCenterProfitsDetailsFulfilled = data => ({
    type: actionTypes.FETCH_DETAILS_FULFILLED,
    payload: data,
})

export const fetchReportCostCenterProfitsDetailsRejected = message => ({
    type: actionTypes.FETCH_DETAILS_REJECTED,
    payload: message,
})

export const fetchReportCostCenterProfitsDetailsCancelled = () => ({
    type: actionTypes.FETCH_DETAILS_CANCELLED,
})

// Export

export const exportReportCostCenterProfitsDetails = (id, year, month, inclCostCenters, inclDrivers, inclTrailers, inclFeatureCosts) => ({
    type: actionTypes.EXPORT_DETAILS,
    payload: {
        id,
        year,
        month,
        inclCostCenters,
        inclDrivers,
        inclTrailers,
        inclFeatureCosts
    },
})

// Clear

export const clearReportCostCenterProfitsDetails = () => ({
    type: actionTypes.CLEAR_DETAILS,
})
